var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pf-content-line"},[_c('span',{staticClass:"pf-content-line__text f-h1 f-uppercase",class:_vm.textClasses,domProps:{"innerHTML":_vm._s(_vm.item.content)}})])}
var staticRenderFns = []

export { render, staticRenderFns }